import React from 'react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Textarea } from '../ui/textarea';
import { ChevronDown, ChevronUp, Send, Loader2 } from 'lucide-react';

/* ─── Admin → Messages tab ─── */
export const AdminMessagesTab = ({
  threads, expandedThread, handleExpandThread, replyText, setReplyText, sending, handleReply, replyEndRef,
}) => {
  return (
          <div className="lm-enter">
            <h2 className="text-2xl font-bold mb-6" data-testid="messages-heading">Messages</h2>
            <div className="space-y-3">
              {threads.map((t) => {
                const isExpanded = expandedThread === t.user_id;
                const lastMsg = t.thread?.[t.thread.length - 1];
                const hasUnread = t.has_unread_admin;
                return (
                  <Card key={t.user_id} className={`overflow-hidden ${hasUnread ? 'border-primary/50 ring-1 ring-primary/20' : ''}`} data-testid={`thread-${t.user_id}`}>
                    <button
                      onClick={() => { handleExpandThread(t.user_id); setReplyText(''); }}
                      className="w-full p-4 flex items-center justify-between hover:bg-muted/30 transition-colors"
                      data-testid={`thread-toggle-${t.user_id}`}
                    >
                      <div className="flex items-center space-x-3">
                        <div className="relative">
                          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-sm font-bold text-primary flex-shrink-0">
                            {t.name?.charAt(0)?.toUpperCase() || '?'}
                          </div>
                          {hasUnread && <span className="absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-destructive border-2 border-background" />}
                        </div>
                        <div className="text-left">
                          <div className="flex items-center gap-2">
                            <p className={`font-semibold ${hasUnread ? '' : 'text-muted-foreground'}`}>{t.name || t.username}</p>
                            {hasUnread && <Badge className="text-xs bg-destructive text-destructive-foreground">New</Badge>}
                          </div>
                          <p className="text-sm text-muted-foreground truncate max-w-md">{lastMsg?.text}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 text-muted-foreground">
                        <span className="text-xs">{t.thread?.length} msgs</span>
                        {isExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                      </div>
                    </button>

                    {isExpanded && (
                      <div className="border-t border-border p-4">
                        <div className="max-h-80 overflow-y-auto space-y-3 mb-4">
                          {t.thread?.map((msg, i) => (
                            <div key={i} className={`flex ${msg.sender === 'user' ? 'justify-start' : 'justify-end'}`}>
                              <div className={`max-w-[80%] px-4 py-2 rounded-2xl text-sm ${msg.sender === 'user' ? 'bg-muted rounded-bl-md' : 'bg-primary text-primary-foreground rounded-br-md'}`}>
                                <p>{msg.text}</p>
                                <p className={`text-xs mt-1 ${msg.sender === 'user' ? 'text-muted-foreground' : 'text-primary-foreground/60'}`}>
                                  {msg.sender === 'user' ? t.name || t.username : 'You'} — {new Date(msg.timestamp).toLocaleString()}
                                </p>
                              </div>
                            </div>
                          ))}
                          <div ref={replyEndRef} />
                        </div>
                        <div className="flex gap-2">
                          <Textarea
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            placeholder="Type your reply..."
                            className="min-h-[60px] flex-1"
                            data-testid={`reply-input-${t.user_id}`}
                          />
                          <Button onClick={() => handleReply(t.user_id)} disabled={sending || !replyText.trim()} className="self-end" data-testid={`reply-btn-${t.user_id}`}>
                            {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                          </Button>
                        </div>
                      </div>
                    )}
                  </Card>
                );
              })}
              {threads.length === 0 && (
                <div className="text-center py-12 text-muted-foreground">No messages yet</div>
              )}
            </div>
          </div>
  );
};
